// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ky9Z","imageUploader":"EGiftCard_imageUploader__2tqKh"};